class CartPopOut extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.cartItems = this.loadCartItems(); // Load cart items from session storage

        // Initial HTML structure and CSS
        this.shadowRoot.innerHTML = `
        <!-- Cart Icon Button -->
        <div class="cart-icon">
        <button class="open-cart" title="View Quote">
            <!-- SVG icon -->
            <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.5 14.25C8.5 16.17 10.08 17.75 12 17.75C13.92 17.75 15.5 16.17 15.5 14.25" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.81 2L5.19 5.63" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M15.19 2L18.81 5.63" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 7.84998C2 5.99998 2.99 5.84998 4.22 5.84998H19.78C21.01 5.84998 22 5.99998 22 7.84998C22 9.99998 21.01 9.84998 19.78 9.84998H4.22C2.99 9.84998 2 9.99998 2 7.84998Z" stroke="#292D32" stroke-width="1.5"/>
                <path d="M3.5 10L4.91 18.64C5.23 20.58 6 22 8.86 22H14.89C18 22 18.46 20.64 18.82 18.76L20.5 10" stroke="#292D32" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
        </button>
        </div>

        <!-- Modal Background Overlay -->
        <div class="modal-overlay" style="display:none;"></div>

        <!-- Cart Modal Structure -->
        <div class="cart-modal" style="display:none;">
            <button class="close-cart">&#x2715;</button> <!-- Unicode for 'X' icon -->
            <div class="cart-content">
                <h2>Quote in Bulk</h2>
                <div class="cart-items">
                    <!-- Cart items will be dynamically added here -->
                </div>
                <!-- Form Section -->
                <div class="form-section">
                    <h3>Your Contact Info</h3>
                    <form id="customer-form">
                        <div class="form-row">
                            <input type="text" id="first-name" name="first_name" placeholder="FIRST NAME">
                            <input type="text" id="last-name" name="last_name" placeholder="LAST NAME">
                        </div>
                        <input type="email" id="email" name="email" placeholder="EMAIL*" required>
                        <h3>Your Project</h3>
                        <input type="text" id="company-name" name="company_name" placeholder="COMPANY NAME">
                        <div class="form-row">
                            <input type="text" id="city" name="city" placeholder="CITY">
                            <input type="text" id="province-state" name="province_state" placeholder="PROVINCE/STATE">
                        </div>
                        <select id="business-type" name="business_type">
                            <option value="" disabled selected>Select a business type...</option>
                            <option value="Designer">Designer</option>
                            <option value="Contractor">Contractor</option>
                            <option value="Distributor">Distributor</option>
                            <option value="Electrical Engineer">Electrical Engineer</option>
                            <option value="Procurement Firm">Procurement Firm</option>
                            <option value="Specification Firm">Specification Firm</option>
                        </select>
                        <input type="text" id="project-title" name="project_title" placeholder="PROJECT TITLE">
                        <input type="date" id="installation-date" name="installation_date" placeholder="EXPECTED INSTALLATION DATE">
                        <input type="text" id="target-price" name="target_price" placeholder="TARGET PRICE">
                        <textarea id="additional-notes" name="additional_notes" placeholder="ADDITIONAL NOTES"></textarea>
                        <input type="submit" value="Submit">
                    </form>
                </div>
            </div>
        </div>

        <!-- Styles -->
        <style>
        .cart-icon {
            position: fixed;
            top: 70px;
            right: 20px;
            z-index: 2000;
        }

        .open-cart {
            background-color: #f0f0f0;
            border: none;
            padding: 8px 11px;
            cursor: pointer;
            border-radius: 5px;
            font-size: 16px;
        }


            .modal-overlay {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                z-index: 1500;
            }

            .cart-modal {
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 80%;
                max-width: 500px;
                background-color: white;
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
                z-index: 2000;
                padding: 20px;
                border-radius: 10px;
                display: flex;
                flex-direction: column;
                align-items: center;
                overflow-y: auto; /* Enable scrolling within the modal */
                  max-height: 80vh; /* Set a maximum height */
            }

            .cart-content {
                width: 100%;
            }

            .cart-items {
                max-height: 300px;
                overflow-y: auto;
                margin-bottom: 20px;
            }
           
            .form-section {
                padding: 20px;
                border-top: 1px solid #ddd;
                background-color: #f7f7f7;
            }

            .form-section h3 {
                margin-top: 20px;
                color: #333;
            }

            #customer-form {
                display: flex;
                flex-direction: column;
                gap: 15px;
            }

            #customer-form input[type="text"],
            #customer-form input[type="email"],
            #customer-form input[type="date"],
            #customer-form select,
            #customer-form textarea {
                padding: 10px;
                border: 1px solid #ccc;
                border-radius: 5px;
                font-size: 12px;
            }

            #customer-form textarea {
                height: 100px;
            }

            #customer-form .form-row {
                display: flex;
                gap: 10px;
            }

            #customer-form .form-row input {
                flex: 1;
            }

            #customer-form input[type="submit"] {
                background-color: #1663B7;
                color: white;
                border: none;
                padding: 10px 15px;
                border-radius: 5px;
                cursor: pointer;
                transition: background-color 0.3s ease;
            }

            #customer-form input[type="submit"]:hover {
                background-color: #598ec7;
            }

        </style>
        `;
    }

    connectedCallback() {
        // Add event listeners
        this.shadowRoot.querySelector('.open-cart').addEventListener('click', () => {
            this.openCart();
        });
        this.shadowRoot.querySelector('.close-cart').addEventListener('click', () => {
            this.closeCart();
        });

        // Apply updated CSS
        const updatedCSS = `
        .cart-modal {
            width: 90%;
            max-width: 800px;
            transition: max-width 0.3s ease-in-out;
        }

        .cart-item-container {
            border: 1px solid #ddd;
            padding: 10px;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .item-image {
            width: auto;
            max-width: 80px;
            height: auto;
            border-radius: 5px;
        }

        .item-details {
            flex-grow: 1;
            font-size: 14px;
            padding-left: 10px;
        }
        .close-cart {
            position: absolute;
            top: 10px;
            right: 10px;
            background-color: transparent;
            border: none;
            font-size: 20px;
            cursor: pointer;
        }
    
        .quantity-decrease, .quantity-increase, .remove-item, .clear-cart {
        background-color: #1663B7;
        color: white;
        padding: 10px 15px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s ease;
        }
    
        .quantity-decrease:hover, .quantity-increase:hover, .remove-item:hover, .clear-cart:hover {
            background-color: #598ec7;
        }
        span.quantity-number {
            display: inline-block;
            background-color: #e0e0e0;
            padding: 5px 10px;
            border-radius: 5px;
            margin: 0 5px;
            text-align: center;
            min-width: 30px; // Ensures the box size stays consistent
            box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }

        @media (max-width: 600px) {
            .cart-modal {
                max-width: 100%;
            }

            .cart-item-container {
                flex-direction: column;
                align-items: start;
            }

            .item-image {
                width: 100%;
                max-width: 100px;
            }

            .item-details {
                padding-left: 0;
            }
        }
        `;
        const styleEl = document.createElement('style');
        styleEl.textContent = updatedCSS;
        this.shadowRoot.appendChild(styleEl);

        
        // Update the cart icon with the total quantity after loading the cart items
        this.updateCartIcon(this.calculateTotalQuantity());
    }

    calculateTotalQuantity() {
        return this.cartItems.reduce((total, item) => total + item.quantity, 0);
    }

    // Method to open the cart modal
    openCart() {
        this.shadowRoot.querySelector('.cart-modal').style.display = 'flex';
        this.shadowRoot.querySelector('.modal-overlay').style.display = 'block';
        this.renderCartItems();
    }

    // Method to close the cart modal
    closeCart() {
        this.shadowRoot.querySelector('.cart-modal').style.display = 'none';
        this.shadowRoot.querySelector('.modal-overlay').style.display = 'none';
    }

    // Method to add items to the cart with quantity handling
    addItem(item) {
        const existingItem = this.cartItems.find(cartItem => cartItem.sku === item.sku);
        if (existingItem) {
            existingItem.quantity += 1; // Increase quantity if item exists
        } else {
            item.quantity = 1; // Set initial quantity for new item
            this.cartItems.push(item);
        }
        this.saveCartItems(); // Save updated cart items to session storage
        this.renderCartItems();
    }

      // Method to update quantity of a cart item
      updateItemQuantity(sku, delta) {
        const item = this.cartItems.find(item => item.sku === sku);
        if (item) {
            item.quantity += delta;
            if (item.quantity <= 0) {
                this.removeItem(sku);
            } else {
                this.saveCartItems();
                this.renderCartItems();
            }
        }
    }

     // Method to remove an item from the cart
     removeItem(sku) {
        this.cartItems = this.cartItems.filter(item => item.sku !== sku);
        this.saveCartItems();
        this.renderCartItems();
    }

    // Method to clear all items from the cart
    clearCart() {
        this.cartItems = [];
        this.saveCartItems();
        this.renderCartItems();
    }


    // Render cart items with quantity controls, and add clear cart button
renderCartItems() {
    const cartItemsContainer = this.shadowRoot.querySelector('.cart-items');
    cartItemsContainer.innerHTML = ''; // Clear current items

    // Calculate total quantity
    let totalQuantity = this.calculateTotalQuantity();
    this.cartItems.forEach(item => {
        const itemElement = document.createElement('div');
        itemElement.classList.add('cart-item-container');
        itemElement.innerHTML = `
            <img src="${item.imageUrl}" alt="${item.name}" class="item-image">
            <div class="item-details">
                <strong>${item.name}</strong> (SKU: ${item.sku})<br>
                Price: $${item.price} | Quantity: ${item.quantity}<br>
                Description: ${item.description}
                <div class="quantity-controls">
                    <button class="quantity-decrease" data-sku="${item.sku}">-</button>
                    <span class="quantity-number">${item.quantity}</span>
                    <button class="quantity-increase" data-sku="${item.sku}">+</button>
                    <button data-sku="${item.sku}" class="remove-item">Remove</button>
                </div>
            </div>
        `;

        cartItemsContainer.appendChild(itemElement);

        // Event listeners for quantity control and remove
        itemElement.querySelector('.quantity-decrease').addEventListener('click', () => {
            this.updateItemQuantity(item.sku, -1);
        });
        itemElement.querySelector('.quantity-increase').addEventListener('click', () => {
            this.updateItemQuantity(item.sku, 1);
        });
        itemElement.querySelector('.remove-item').addEventListener('click', () => {
            this.removeItem(item.sku);
        });
    });

         // Update cart icon button text
         this.updateCartIcon(totalQuantity);

       // Manage the Clear Cart button
    let clearCartButton = this.shadowRoot.querySelector('.clear-cart');
    if (this.cartItems.length > 0) {
        if (!clearCartButton) {
            clearCartButton = document.createElement('button');
            clearCartButton.textContent = 'Clear Cart';
            clearCartButton.className = 'clear-cart'; // Assign class for easy selection
            clearCartButton.addEventListener('click', () => this.clearCart());
            this.shadowRoot.querySelector('.cart-content').appendChild(clearCartButton);
        }
    } else {
        // If no items and button exists, remove it
        if (clearCartButton) {
            clearCartButton.remove();
        }
    }
    }

    updateCartIcon(totalQuantity) {
        const cartButton = this.shadowRoot.querySelector('.open-cart');
        cartButton.innerHTML = `
        <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.5 14.25C8.5 16.17 10.08 17.75 12 17.75C13.92 17.75 15.5 16.17 15.5 14.25" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.81 2L5.19 5.63" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.19 2L18.81 5.63" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2 7.84998C2 5.99998 2.99 5.84998 4.22 5.84998H19.78C21.01 5.84998 22 5.99998 22 7.84998C22 9.99998 21.01 9.84998 19.78 9.84998H4.22C2.99 9.84998 2 9.99998 2 7.84998Z" stroke="#292D32" stroke-width="1.5"/>
            <path d="M3.5 10L4.91 18.64C5.23 20.58 6 22 8.86 22H14.89C18 22 18.46 20.64 18.82 18.76L20.5 10" stroke="#292D32" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <span class="quantity-badge">${totalQuantity}</span>
        `;
    
        // Update the CSS for the quantity badge
    const styleEl = this.shadowRoot.querySelector('style');
    const additionalCSS = `
    .quantity-badge {
        background-color: #1663B7;
        color: white;
        border-radius: 50%;
        padding: 4px 8px;
        font-size: 14px;
        position: absolute;
        top: 5px;
        right: 0;
        transform: translate(50%, -50%);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    `;
    styleEl.textContent += additionalCSS;


    }

    // Save cart items to session storage
    saveCartItems() {
        sessionStorage.setItem('cartItems', JSON.stringify(this.cartItems));
    }

    // Load cart items from session storage
    loadCartItems() {
        const savedItems = sessionStorage.getItem('cartItems');
        return savedItems ? JSON.parse(savedItems) : [];
    }
}

// Define the new element
customElements.define('cart-popout', CartPopOut);